module.exports = "<div class=\"wrapper\">\n    <dx-menu #menu\n             [dataSource]=\"items\"\n             displayExpr=\"displayName.name\"\n             itemsExpr=\"functions\"\n             orientation=\"horizontal\"\n             submenuDirection=\"auto\"\n             [hideSubmenuOnMouseLeave]=\"false\"\n             (onItemClick)=\"onItemClick($event)\"\n             width=\"100%\"\n             visible=true\n             class=\"top-menu\">\n    </dx-menu>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/top-menu/top-menu.component.html
// module id = ./src/app/components/top-menu/top-menu.component.html
// module chunks = main